export const Images = {
  chevronDown: require('./images/chevron-down.png'),
  chevronUp: require('./images/chevron-up.png'),
};
